const message = {
	namespaced: true,
	state: {
		message: (localStorage.getItem('lastGmail')) ? JSON.parse(localStorage.getItem('lastGmail')) : '{}'
	},
	getters: {
		getMessage(state){
			return state.message;
		}
	},
	mutations: {
		setMessage(state, message){
			state.message = message
		}
	},
		actions: {
		setMessage({ commit }, message){
			localStorage.setItem('lastGmail', JSON.stringify(message));
			commit('setMessage', message)
		}
	}
}

export default message;


// WEBPACK FOOTER //
// ./src/store/message.js